const objectToQueryString = (query) => new URLSearchParams(query).toString();

export default objectToQueryString;
